module.exports = __webpack_public_path__ + "static/media/logoEasygoing.23c71abf.png";